(function(){
	if( typeof APPS === "undefined") { APPS = {}; }
	APPS.videoseries = {};
	
	var Router = Marionette.AppRouter.extend({
		appRoutes: {
			"videoseries": "videoseries"

		}
	})
	
	var API = {
		videoseries: function(){
			APPS.videoseries.page.show()
		}
	}
	
	APP.on("before:start", function(){
		new Router({ controller: API })
	})
})();

